<template>
  <div>
    <b-modal
      id="modalCompetence"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row d-flex justify-content-center">
            <div class="col-md-12 col-lg-8">
              <div class="form-group">
                <label for="domaine">Domaine de compétence </label>
                <v-custom-select
                  label="nom"
                  id="domaine"
                  :options="domaines"
                  :reduce="(domaine) => domaine.uuid"
                  v-model="selectedDomaine"
                  placeholder="Domaine de compétence"
                  @input="onChangeDomaine"
                >
                  <template v-slot:option="{ nom }">
                    <h5 style="margin: 0">{{ nom }}</h5>
                  </template>
                  <template #no-options> Aucune donnée </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="domaine"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
              </div>
            </div>
          </div>
          <div class="row mt-n4">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body mt-n2 mb-n2">
                  <div class="row mt-n2 d-flex justify-content-center">
                    <div class="col-md-12 col-lg-12">
                      <cool-select
                        v-model="selectedCompetence"
                        :items="competences"
                        item-text="nom"
                        placeholder="Recherche compétence"
                        @select="onSelectedComptence"
                        :search-text.sync="searchText"
                      >
                        <template #no-data>
                          {{
                            competences.length
                              ? 'Aucun resultat.'
                              : '2 caratères pour lancer la recherche.'
                          }}
                        </template>
                        <template #item="{ item }">
                          <div class="item">
                            <div style="font-size: 1.1em">
                              <span class="d-block">
                                {{ item.nom }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </cool-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-alert
            :show="itemListErrorMessage !== null"
            dismissible
            variant="danger"
          >
            <span v-html="itemListErrorMessage"></span>
          </b-alert>

          <div class="row mt-n4 mb-4">
            <div class="col-md-12">
              <ul class="list-group">
                <li
                  v-for="(item, index) in form.item_lists"
                  :key="index"
                  class="list-group-item d-flex justify-content-between align-items-center"
                >
                  {{ item.nom }}
                  <a class="cursor-pointer" @click.prevent="removeItem(index)">
                    <i class="fa fa-trash font-size-17 text-danger"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalCompetence')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Enregistrer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/rh/employe-competence';
import { CoolSelect } from 'vue-cool-select';
import Form from 'vform';
export default {
  data() {
    return {
      form: new Form({
        employe: '',
        item_lists: [],
        competencable_type: this.competencableType,
        competencable_uuid: null,
      }),
      selectedDomaine: null,
      selectedCompetence: null,
      searchText: null,

      domaines: [],
      competences: [],
      currentCompetences: [],
      itemListErrorMessage: null,
      titleModal: 'Enregistrement de compétences',
    };
  },
  components: {
    CoolSelect,
  },
  methods: {
    onChangeDomaine() {
      this.competences = [];
      if (this.selectedDomaine) {
        let domaine = window._.find(
          this.domaines,
          (d) => d.uuid === this.selectedDomaine
        );

        if (domaine) {
          this.competences = domaine.competences.filter(
            (c) => !this.currentCompetences.includes(Number(c.id))
          );
        }
      } else {
        this.competences = [];
      }
    },
    onSelectedComptence(select) {
      if (select) {
        var objExiste = window._.find(
          this.form.item_lists,
          (o) => o.uuid === select.uuid
        );

        if (!objExiste) {
          let item = {
            uuid: select.uuid,
            nom: select.nom,
          };

          this.form.item_lists.push(item);
        }

        this.searchText = null;
        this.selectedCompetence = null;
      }
    },
    removeItem(index) {
      this.form.item_lists.splice(index, 1);
    },
    async create() {
      this.itemListErrorMessage = null;
      this.currentCompetences = this.currentEmploye.competences
        .filter((c) => c.id !== null)
        .map((item) => item.id);

      this.selectedDomaine = null;
      this.domaines = [];
      this.titleModal = 'Enregistrement de compétences';
      this.form.reset();
      this.form.clear();
      await window.axios
        .get(URL.GET_REQUIREMENTS)
        .then((resp) => {
          this.domaines = resp.data.domaines;
        })
        .catch();

      await this.$bvModal.show('modalCompetence');
    },
    submit() {
      this.itemListErrorMessage = null;

      this.$bvModal.hide('modalCompetence');
      this.form.employe = this.currentEmploye.uuid;
      this.form.competencable_uuid = this.competencableUuid;
      this.form
        .post(URL.COMPETENCE)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.form.clear();
          this.$emit('onSuccessSavedCompetence');
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            }
            return false;
          });
          this.$bvModal.show('modalCompetence');
        });
    },
  },
  props: ['currentEmploye', 'competencableUuid', 'competencableType'],
};
</script>

<style scoped lang="scss"></style>
